import { useQuery } from 'react-query';

import { getTopEntityOptions } from '@utils/backend-api/entities';
import { AutocompleteRecord } from '@utils/interfaces';

const TOP_ENTITY_OPTIONS_KEY = 'TOP_ENTITY_OPTIONS_KEY';

export default function useEntitiesTop() {
  const { data, isLoading } = useQuery<AutocompleteRecord[]>(
    TOP_ENTITY_OPTIONS_KEY,
    getTopEntityOptions
  );
  return { data, isLoading };
}
